import "./index.css";
import "./assets/fonts/lato.css";

import { KindeProvider } from "@kinde-oss/kinde-auth-react";
import { config } from "@noted/configuration";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./app";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter basename="/landing">
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools />
        <KindeProvider
          audience={config.auth.audience}
          clientId={config.auth.clientId}
          domain={config.auth.domain}
          logoutUri={config.landingUrl}
          redirectUri={config.landingUrl}
          useInsecureForRefreshToken={import.meta.env.MODE === "development"}
        >
          <App />
        </KindeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);
